/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * a Final Risk Override history record
 * @export
 * @interface InternalApiFinalRiskOverrideHistoryRecord
 */
export interface InternalApiFinalRiskOverrideHistoryRecord {
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiFinalRiskOverrideHistoryRecord
     */
    level?: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiFinalRiskOverrideHistoryRecord
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiFinalRiskOverrideHistoryRecord
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRiskOverrideHistoryRecord
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRiskOverrideHistoryRecord
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRiskOverrideHistoryRecord
     */
    addedByUserName?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRiskOverrideHistoryRecord
     */
    endedByUserName?: string;
}



/**
 * Check if a given object implements the InternalApiFinalRiskOverrideHistoryRecord interface.
 */
export function instanceOfInternalApiFinalRiskOverrideHistoryRecord(value: object): value is InternalApiFinalRiskOverrideHistoryRecord {
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function InternalApiFinalRiskOverrideHistoryRecordFromJSON(json: any): InternalApiFinalRiskOverrideHistoryRecord {
    return InternalApiFinalRiskOverrideHistoryRecordFromJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideHistoryRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRiskOverrideHistoryRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'level': json['level'] == null ? undefined : InternalApiFinalRiskLevelFromJSON(json['level']),
        'startTime': (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'reason': json['reason'],
        'comment': json['comment'],
        'addedByUserName': json['addedByUserName'] == null ? undefined : json['addedByUserName'],
        'endedByUserName': json['endedByUserName'] == null ? undefined : json['endedByUserName'],
    };
}

export function InternalApiFinalRiskOverrideHistoryRecordToJSON(json: any): InternalApiFinalRiskOverrideHistoryRecord {
    return InternalApiFinalRiskOverrideHistoryRecordToJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideHistoryRecordToJSONTyped(value?: InternalApiFinalRiskOverrideHistoryRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'level': InternalApiFinalRiskLevelToJSON(value['level']),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'reason': value['reason'],
        'comment': value['comment'],
        'addedByUserName': value['addedByUserName'],
        'endedByUserName': value['endedByUserName'],
    };
}

